<template>
  <div>
    <div class="row pb-5 subteam">
      <div class="col-12 col-lg-10 mx-auto mt-n5">
        <div class="bg-white rounded py-5 px-3 p-md-5">
          <div class="col-12 mx-auto mb-4">
            <div v-html="team.content"></div>
          </div>
          <h1 class="text-center mb-5">{{ team.subtitle }}</h1>

          <div class="row">
            <div class="col-12 item mb-3"
                  :class="[team.sub.length == 4 ? 'col-md-6' : 'col-md-4']"
                  style="overflow:hidden;"
                  :style="[team.sub.length == 4 ? { height: '220px' } : { height: '70vh' }]"
                  v-for="(item, i) in team.sub" :key="i">
              <ImageBox :item="item"/>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageBox from "@/components/media/ImageBox.vue";

export default {
  name: "ListSubTeams",

  head() {
    return this.$head({
      title: `${this.team.title} | `,
    });
  },

  props: {
    team: Object
  },

  components: {
    ImageBox
  }
};
</script>

<style lang="scss" >
.subteam {
  .item {
    @include media-breakpoint-down(md) {
      margin: 5px 0;
      max-height: 250px;
    }

    .hidden-content {
      p {
        @include media-breakpoint-down(md) {
          overflow: hidden;
        }
      }
    }
  }
}
</style>